module.exports = __webpack_public_path__ + "static/img/25.5ec2afa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/25.jpg
// module id = y8aD
// module chunks = 1